import { TextField, InputAdornment, Box } from '@mui/material';

export default function RoundedInput({
    placeholder = 'Enter text',
    icon,
    value,
    onChange,
    type = 'text',
    disabled = false,
    marginBottom,
}) {
    return (
        <Box
            sx={{
                width: '100%',
                mb: marginBottom ? marginBottom : 0,
            }}
        >
            <TextField
                fullWidth
                type={type}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start" sx={{ color: 'rgb(39,90,71)' }}>
                            {icon}
                        </InputAdornment>
                    ),
                    sx: {
                        borderRadius: '40px',
                        height: '48px',
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgb(39,90,71)',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgb(39,90,71)',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgb(39,90,71)',
                            borderWidth: '2px',
                        },
                        color: 'rgb(39,90,71)', // text + cursor matches color
                    },
                }}
                inputProps={{
                    style: { color: 'rgb(39,90,71)' },
                }}
            />
        </Box>
    );
}
